import styled from "@emotion/styled";
import { space, typography } from "@smartsheet/design-tokens";
import { datePickerTheme } from "../../dialog/styled/datePickerTheme";
export const RangeInputsLabelBetween = styled("span")`
    padding: 0 ${space.space20};
    font-weight: ${typography.fontWeight.medium};
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return datePickerTheme.dateRangePickerInputTextSeparatorColor(themeMode);
}};
`;
//# sourceMappingURL=RangeInputsLabelBetween.js.map